import React from 'react';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import InfoTable from '../../../../components/table/InfoTable';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { useQuery } from '@tanstack/react-query';
import { settlementQuery } from '../../../settlement/queries';
import { convertSettlementStatus } from '../../../settlement/utils';
import { formatDate } from '../../../../lib/utils/date/formatDate';
import formatNumberWithComma from '../../../../lib/utils/common/formatComma';

const OrderBalanceInfo = (props) => {
  const { balanceInfo } = props;

  const settlementId = balanceInfo.balanceId;

  const { data, isLoading } = useQuery(settlementQuery.detail(settlementId));

  const { settlementItem } = data ?? {};

  if (!balanceInfo || isLoading) return null;

  return (
    <div className="order-detail-content">
      {/* 정산 상세 정보 */}
      <div className="order-detail-section">
        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">정산번호</td>
              <td className="tc">{settlementId}</td>
            </tr>
            <tr>
              <td className="label tc">정산 기준일</td>
              <td className="tc">{formatDate(settlementItem.baseDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
            </tr>
            <tr>
              <td className="label tc">정산 예정일</td>
              <td className="tc">{formatDate(settlementItem.dueDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
            </tr>
            <tr>
              <td className="label tc">정산 완료일</td>
              <td className="tc">{formatDate(settlementItem.completeDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
            </tr>
            <tr>
              <td className="label tc">정산상태</td>
              <td className="tc">{convertSettlementStatus(settlementItem.status)}</td>
            </tr>
            <tr>
              <td className="label tc">메모</td>
              <td className="tc">{settlementItem.memo}</td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      <div className="order-detail-section">
        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">브랜드명</td>
              <td className="tc">
                <OpenBrandDetail
                  text={`${settlementItem.brand.name}(${settlementItem.brand.id})`}
                  storeId={settlementItem.brand.id}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">총 결제금액</td>
              <td className="tc">{formatNumberWithComma(settlementItem.paidAmount)}</td>
            </tr>
            <tr>
              <td className="label tc">정산 대기금액</td>
              <td className="tc">
                {['ready', 'hold'].includes(settlementItem.status)
                  ? formatNumberWithComma(settlementItem.settlementAmount)
                  : '-'}
              </td>
            </tr>
            <tr>
              <td className="label tc">정산 완료금액</td>
              <td className="tc">
                {['completed'].includes(settlementItem.status)
                  ? formatNumberWithComma(settlementItem.settlementAmount)
                  : '-'}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </div>
  );
};

export default OrderBalanceInfo;
